import { atom, atomFamily, selector, selectorFamily } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

export const WX_ID_SIGMET ='WX_ID_SIGMET';
export const WX_ID_VAA ='WX_ID_VAA';
export const WX_ID_SIGWX ='WX_ID_SIGWX';
export const WX_ID_UKMET ='WX_ID_UKMET';
export const WX_ID_SATELLITE ='WX_ID_SATELLITE';
export const WX_ID_ASCSCALE ='WX_ID_ASCSCALE';
export const WX_ID_ACOS ='WX_ID_ACOS';
export const WX_ID_RADAR ='WX_ID_RADAR';
export const WX_ID_SURFACEANALYSIS ='WX_ID_SURFACEANALYSIS';
export const WX_ID_TROPICALCYCLONE ='WX_ID_TROPICALCYCLONE';
export const WX_ID_METARTAF ='WX_ID_METARTAF';

export const WX_SETTINGS = {
  [WX_ID_SIGMET] : {visible: false, crossSection: false, altitude: 'range'},
  [WX_ID_VAA] : {visible: false, crossSection: false, altitude: 'range'},
  [WX_ID_SIGWX] : {visible: false, crossSection: false, altitude: 'range'},
  [WX_ID_UKMET] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_SATELLITE] : {visible: false, crossSection: true, altitude: false},
  [WX_ID_ASCSCALE] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_ACOS] : {visible: false, crossSection: true, altitude: 'individual'},
  [WX_ID_RADAR] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_SURFACEANALYSIS] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_TROPICALCYCLONE] : {visible: false, crossSection: false, altitude: false},
  [WX_ID_METARTAF] : {visible: false, crossSection: false, altitude: false},
}

export const isWXContents = (id) => {
  return Object.keys(WX_SETTINGS).includes(id);
}

const weatherVisibleFamily = atomFamily({
  key: 'weatherVisibleFamily',
  default: selectorFamily({
    key: 'weatherVisibleFamilySelector',
    get: param => () => {
      return getCustomerSettings(`layerConfig.${param}.checked`);
    }
  })
});

export const selectedWeatherList = atom({
  key: 'selectedWeatherList',
  default: selector({
    key: 'selectedWeatherListSelector',
    get: () => {
      const layerConfig = getCustomerSettings('layerConfig');
      const menuWeatherOrder = getCustomerSettings('menuWeatherOrder');
      const list = [];
      menuWeatherOrder.forEach(wx => {
        if(layerConfig[wx].checked) {
          list.push(wx);
        }
      });
      return list;
    }
  })
});

export const weatherVisibleWithID = selectorFamily({
  key: 'weatherVisibleWithID',

  get: (id) => ({get}) => {
    return get(weatherVisibleFamily(id));
  },

  set: (id) => ({set, get}, visible) => {
    set(weatherVisibleFamily(id), visible);
    const oldList = get(selectedWeatherList);
    let newList;
    if (visible) {
      newList = [...oldList, id];
    } else {
      const index = oldList.findIndex(_id => _id === id);
      newList = [...oldList.slice(0, index), ...oldList.slice(index + 1)]
    }
    set(selectedWeatherList, newList);
  }
});

export const toggleWeatherVisibleWithID = selectorFamily({
  key: 'toggleWeatherVisibleWithID',
  set: (id) => ({set, get}) => {
    const visible = get(weatherVisibleWithID(id))
    set(weatherVisibleWithID(id), !visible);
  }
});

export const weatherTimeWithID = atomFamily({
  key: 'weatherTimeWithID',
  default:{}
});
